// Deprecated: This component is no longer in use. It was used to display the Live case study on the home page.

import React from 'react'
import PropTypes from 'prop-types'

import LiveLogo from 'images/index/live.svg'
import LiveImage from 'images/index/live-image-desktop.webp'
import LiveImageMobile from 'images/index/live-image-mobile.webp'
import Heading from 'components/Heading'
import ProjectPageLink from 'components/ProjectPageLink'
import { LIVE_PROJECT_ROUTE } from 'routes/constants'

const Live = ({ withArrow }) => (
  <>
    <div className="live-image">
      <picture>
        <source media="(max-width: 991px)" srcSet={LiveImageMobile} />
        <source media="(min-width: 992px)" srcSet={LiveImage} />
        <img src={LiveImage} loading="lazy" alt="Woman smiling" />
      </picture>
    </div>
    <div className="casestudy-container --centered">
      <ProjectPageLink linkTo={LIVE_PROJECT_ROUTE}>
        <div className="scalable-block">
          <div className="live-logo">
            <LiveLogo />
          </div>
          <div className="live-body casestudy-body">
            <Heading text="Video; Wherever, Whenever" withArrow={withArrow} />
          </div>
        </div>
      </ProjectPageLink>
    </div>
  </>
)

Live.propTypes = {
  withArrow: PropTypes.bool,
}

export default Live
